'use client';

import Image from 'next/image';
import ReactPlayer from 'react-player';

import { getImageUrl } from '@repo/utils';

import { tw } from '../../utils';

interface UserPFPProps {
  publicUrl: string;
  type: string;
}

export const UserPFP: React.FC<UserPFPProps> = ({
  publicUrl,
  type,
}: UserPFPProps) => {
  const defaultAvatar = getImageUrl('/stoodio/images/pfpPlaceholder.svg');

  const url = publicUrl || defaultAvatar;
  const isVideo = type === 'video';

  return (
    <>
      {isVideo ? (
        <ReactPlayer
          muted={true}
          loop
          playing
          playsinline
          height='100%'
          width='100%'
          className={tw('block h-full w-full overflow-hidden')}
          url={url}
        />
      ) : (
        <Image
          fill
          alt='Profile Picture'
          src={url}
          className='bg-[#F2F2F2]'
          sizes='100%'
          priority
        />
      )}
    </>
  );
};
